module.exports = __webpack_public_path__ + "static/media/ps.930fc949.svg";